import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { CreditCard, X, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { paymentInformation, paymentOrder, paymentVerification, topUpsOrder, topUpVerification, userSubscriptionDetails } from "@/Services/Service";
import { toast as toast1 } from "sonner";
import html2pdf from "html2pdf.js";
import { LanguageStore } from "@/Services/LanguageStore";
import { BridgeLanguage } from "@/Services/Language";
import { decodeWithBase64 } from "@/Services/encodedecode";

const UpgradePage = ({ showUpgrade, setShowUpgrade }) => {
    const invoiceRef = useRef();
    const [selectcost, setSelectedCost] = useState(null);
    const [invoicedisplay, setInvoiceDisplay] = useState(false);
    const [otherinvoicedisplay, setOtherInvoiceDisplay] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [customerplace, setCustomerplace] = useState("");
    const [taxableamount, setTaxabelAmount] = useState(null);
    const [cgstamount, setCGSTAmount] = useState(null);
    const [sgstamount, setSGSTAmount] = useState(null);
    const [totalammount, setTotalAmount] = useState(null);
    const [invoicenumber, setInvoicenumber] = useState(null);
    const [ammount, setAmmount] = useState(0);
    const [isUserPro, setUserPro] = useState(false);
    const [billingCycle, setBillingCycle] = useState<'monthly' | 'yearly'>('monthly');
    const [days, setdays] = useState(0);
    const [expiredate, setexpiredate] = useState('');
    const [bridgeplan, setbridgeplan] = useState([]);
    const [selectedCurrencyTopup, setSelectedCurrencyTopup] = useState<'INR' | 'USD'>('INR');
    const [selectedPlanIdx, setSelectedPlanIdx] = useState<number | null>(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [topuptype, setTopupType] = useState("");
    const [topupdata, setTopupdata] = useState("");

    const LanguageString = (number: any) => {
        let LangData = LanguageStore.allLanguages;
        if (Object.keys(LangData).length === 0) {
            let localLang = localStorage.getItem('BridgeLanguageStrings');
            if (localLang) {
                LangData = JSON.parse(decodeWithBase64(localLang));
            }
        }
        if (LangData && LangData[number]) {
            return LangData[number];
        }
        else {
            return BridgeLanguage(number);
        }
    }

    useEffect(() => {
        checkForSubscription();
        FetchingPaymentInfo();
    }, [])

    const checkForSubscription = async () => {
        try {
            const subscriptionData = await userSubscriptionDetails("Subscription");
            if (subscriptionData['ErrorCode'] === 3003) {
                const userType = subscriptionData['ErrorMessage']['UserType'];
                let isActive = subscriptionData['ErrorMessage']['Active'];
                if ((userType === 'Pro' || userType === 'ProYearly') && isActive) {
                    setUserPro(true);
                }
                let expiredate = subscriptionData['ErrorMessage']['ExpiresAt']
                const currentEpoch = Math.floor(Date.now() / 1000); // now
                const { result, totalDays, expireDateFormatted } = calculateDaysSplitByMonth(currentEpoch, expiredate);
                setdays(totalDays)
                setexpiredate(expireDateFormatted)
            }
        } catch (error) {

        }
    }
    const calculateDaysSplitByMonth = (currentEpoch, expireEpoch) => {
        let currentDate = new Date(currentEpoch * 1000);
        const expireDate = new Date(expireEpoch * 1000);

        let result = [];
        let totalDays = 0;

        while (
            currentDate.getFullYear() < expireDate.getFullYear() ||
            (currentDate.getFullYear() === expireDate.getFullYear() &&
                currentDate.getMonth() <= expireDate.getMonth())
        ) {
            const year = currentDate.getFullYear();
            const month = currentDate.getMonth();
            const isCurrentMonth = (year === expireDate.getFullYear() && month === expireDate.getMonth());

            const daysInMonth = new Date(year, month + 1, 0).getDate();
            const currentDay = currentDate.getDate();

            let daysLeftInMonth;
            let endDay;

            if (isCurrentMonth) {
                daysLeftInMonth = expireDate.getDate() - currentDay;
                endDay = expireDate.getDate();
            } else {
                daysLeftInMonth = daysInMonth - currentDay;
                endDay = daysInMonth;
            }

            daysLeftInMonth += 1; // Include today
            if (daysLeftInMonth < 0) daysLeftInMonth = 0;

            totalDays += daysLeftInMonth;

            result.push({
                year,
                month: month + 1, // month is 0-based in JS
                startDay: currentDay,
                endDay: endDay,
                days: daysLeftInMonth,
            });
            currentDate = new Date(year, month + 1, 1);
        }
        return { result, totalDays, expireDateFormatted: formatDate(expireDate) };
    };

    const formatDate = (dateObj) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return dateObj.toLocaleDateString(undefined, options);
    };

    const FetchingPaymentInfo = async () => {
        let data = await paymentInformation();
        if (data['ErrorCode'] === 3000) {
            const FreeData = data['ErrorMessage']['Free'][0];
            let propayments = data['ErrorMessage']['Pro'];

            let IndiaMonthly = { Cost: 0, BridgeTopup: [] };
            let IndiaYearly = null;
            if (propayments && Array.isArray(propayments['India'])) {
                IndiaMonthly = propayments['India'][0] || { Cost: 0, BridgeTopup: [] };
                IndiaYearly = propayments['India'][1] || null;
            }

            let OtherMonthly = { Cost: 0, BridgeTopup: [] };
            let OtherYearly = null;
            if (propayments && Array.isArray(propayments['Others'])) {
                OtherMonthly = propayments['Others'][0] || { Cost: 0, BridgeTopup: [] };
                OtherYearly = propayments['Others'][1] || null;
            }

            let cost = IndiaMonthly['Cost'];
            let othercost = OtherMonthly['Cost'];
            if (cost === 0 || othercost === 0) {
                setUserPro(true);
            }
            let json = {
                'India': cost,
                "other": othercost,
                'IndiaYearly': IndiaYearly ? IndiaYearly['Cost'] : cost * 10,
                'otherYearly': OtherYearly ? OtherYearly['Cost'] : othercost * 10
            }
            setSelectedCost(json)
            let Indiabridgedata = IndiaMonthly['BridgeTopup'] || []
            let Otherbridgedata = OtherMonthly['BridgeTopup'] || []
            let bridge = [];
            const map = new Map();
            Indiabridgedata.forEach(element => {
                let json = {
                    "PlanType": "Bridge",
                    "Limit": element.Limit,
                    "IndianCost": element.Cost,
                }
                bridge.push(json)
            });
            Otherbridgedata.forEach(element => {
                if (element.Cost !== undefined && element.Cost !== null && !isNaN(element.Cost)) {
                    let json = {
                        "PlanType": "Bridge",
                        "Limit": element.Limit,
                        "OtherCost": element.Cost,
                    }
                    bridge.push(json)
                }
            });

            bridge.forEach(item => {
                const key = item.Limit;
                if (!map.has(key)) {
                    map.set(key, { PlanType: item.PlanType, Limit: item.Limit });
                }
                if (item.IndianCost !== undefined) {
                    map.get(key).IndianCost = item.IndianCost;
                }
                if (item.OtherCost !== undefined) {
                    map.get(key).OtherCost = item.OtherCost;
                }
            });
            let bridgePlans = Array.from(map.values());
            setbridgeplan(bridgePlans);
        }
    }

    const Upgrade = async (type: string, planType: string = "Pro") => {
        let country: string;
        if (type === 'INR') {
            country = 'India'
        } else {
            country = 'Others'
        }
        let data = await paymentOrder(country, planType);
        if (data['ErrorCode'] === 3001) {
            displayRazorpay(data['ErrorMessage'], country)
        } else if (data['ErrorCode'] === 2000) {
            toast1.error("No results");
            return;
        }
        else {
            // setIsLoading(false)
        }
    }

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    async function displayRazorpay(data, country) {
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );

        if (!res) {
            alert(LanguageString("1967"));
            return;
        }
        let key = data['publicKey'];
        let orderid = data['OrderId'];
        let ammount = data['Amount'];
        let currency = data['Currency'];
        let name = data['Name'];
        let description = data['Description']

        const options = {
            key: key,
            amount: ammount,
            currency: currency,
            name: name,
            description: description,
            // image: { logo },
            order_id: orderid,
            handler: async function (response) {
                const data = {
                    "payment_id": response.razorpay_payment_id,
                    "order_id": response.razorpay_order_id,
                    "signature": response.razorpay_signature,
                };
                let paymentverif = await paymentVerification(data);
                if (paymentverif['ErrorCode'] === 3002) {
                    if (country === 'India') {
                        setInvoiceDisplay(true)
                    } else {
                        setOtherInvoiceDisplay(true)
                    }
                    invoice(paymentverif['ErrorMessage'], country)
                    toast1.success(LanguageString("1705"))
                } else {
                    toast1.error(LanguageString("1706"))
                }
            },
            prefill: {
                name: "",
                email: "",
                contact: "",
            },
            notes: {
                address: "Cosmitude Softwares",
            },
            theme: {
                color: "#61dafb",
            },
        };
        const RazorpayCtor = (window as any).Razorpay;
        const rzp = new RazorpayCtor(options);
        rzp.open();
    }

    const invoice = (data, country) => {
        if (country === 'India') {
            setInvoiceDisplay(true)
            const result = calculateGSTBreakdown((data.Amount) / 100);
            setAmmount((data.Amount) / 100)
            setTaxabelAmount(result.taxableAmount)
            setCGSTAmount(result.cgst)
            setSGSTAmount(result.sgst)
            setTotalAmount(result.total)
            setInvoicenumber(data.Invoice)
        } else {
            const result = calculateGSTBreakdown((data.Amount) / 100);
            setAmmount((data.Amount) / 100)
            setOtherInvoiceDisplay(true)
            setTotalAmount(result.total)
            setInvoicenumber(data.Invoice)
        }
    };

    function calculateGSTBreakdown(totalAmount) {
        const taxableAmount = +(totalAmount / 1.18).toFixed(2);
        const cgst = +(taxableAmount * 0.09).toFixed(2);
        const sgst = +(taxableAmount * 0.09).toFixed(2);
        const roundedTotal = +(taxableAmount + cgst + sgst).toFixed(2);

        return {
            taxableAmount,
            cgst,
            sgst,
            total: totalAmount
        };
    }

    // const handleDownloadPDF = () => {
    //     if (customerName && customerplace) {
    //         const element = invoiceRef.current;
    //         html2pdf().from(element).set({
    //             margin: 0.5,
    //             filename: invoicenumber,
    //             image: { type: "jpeg", quality: 0.98 },
    //             html2canvas: { scale: 9 },
    //             jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    //         }).save()
    //     } else {
    //         toast1.warning('Enter Name and Place')
    //     }

    // };

    const handleDownloadPDF = async () => {
        if (!(customerName && customerplace)) {
            toast1.warning(LanguageString('1786'));
            return;
        }

        const orig = invoiceRef.current as HTMLElement | null;
        if (!orig) {
            toast1.error(LanguageString("2174"));
            return;
        }

        // Create a container on-screen but almost invisible (so it can be rendered)
        const container = document.createElement('div');
        container.style.position = 'fixed';
        container.style.left = '0';
        container.style.top = '0';
        container.style.width = '720px';   // ~7.5" printable width for Letter page with 0.5" margins
        container.style.maxWidth = '720px';
        container.style.background = '#fff';
        container.style.opacity = '0.01';  // visible to renderer, not to the user
        container.style.pointerEvents = 'none';
        container.style.zIndex = '2147483647';

        // Clone the invoice content
        const clone = orig.cloneNode(true) as HTMLElement;
        clone.style.width = '720px';
        clone.style.maxWidth = '720px';
        clone.style.background = '#ffffff';
        clone.style.opacity = '1';
        clone.style.transform = 'none';
        clone.style.filter = 'none';
        clone.style.pointerEvents = 'auto';

        // Make tables render predictably within width
        clone.querySelectorAll('table').forEach((t) => {
            const el = t as HTMLElement;
            el.style.tableLayout = 'fixed';
            el.style.width = '100%';
            el.style.wordBreak = 'break-word';
            el.style.borderCollapse = 'collapse';
        });

        // Replace inputs/selects/textareas with plain text so values are captured
        const replaceFieldWithText = (el: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement) => {
            const wrap = document.createElement('div');
            const cs = getComputedStyle(el);
            wrap.style.padding = cs.padding || '8px';
            wrap.style.minHeight = cs.height || '24px';
            wrap.style.whiteSpace = 'pre-wrap';
            wrap.style.border = '1px solid rgba(0,0,0,0.05)';
            wrap.textContent =
                (el as HTMLInputElement).value ||
                el.getAttribute('value') ||
                el.getAttribute('placeholder') ||
                '';
            el.parentNode?.replaceChild(wrap, el);
        };
        clone.querySelectorAll('input, textarea, select').forEach((n) => replaceFieldWithText(n as any));

        container.appendChild(clone);
        document.body.appendChild(container);

        // Wait two frames to ensure layout & fonts are ready
        await new Promise((r) => requestAnimationFrame(() => r(null)));
        await new Promise((r) => requestAnimationFrame(() => r(null)));

        try {
            await html2pdf()
                .set({
                    margin: 0.5,
                    filename: invoicenumber || 'invoice',
                    image: { type: 'jpeg', quality: 0.98 },
                    html2canvas: {
                        scale: 2,
                        useCORS: true,
                        backgroundColor: '#ffffff',
                        scrollX: 0,
                        scrollY: 0,
                        windowWidth: 720, // match our forced width
                    },
                    jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                })
                .from(clone) // render the CLONE, not the container or the modal
                .save();
        } finally {
            document.body.removeChild(container);
        }
    };
    const getFormattedDate = () => {
        const date = new Date();

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();

        // Add suffix (st, nd, rd, th)
        const getDaySuffix = (d) => {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${day}${getDaySuffix(day)} ${month} ${year}`;
    };
    const cancel = () => {
        setInvoiceDisplay(false)
        setShowUpgrade(false)
    };
    const Othercancel = () => {
        setOtherInvoiceDisplay(false)
        setShowUpgrade(false)
    };

    const getPlanPrice = (plan: any) => {
        if (!plan) return '';
        if (selectedCurrencyTopup === 'INR') {
            return plan?.IndianCost !== undefined ? `₹${plan.IndianCost}` : '';
        } else {
            return plan?.OtherCost !== undefined ? `$${plan.OtherCost}` : '';
        }
    };

    const onProceedTopup = () => {
        if (selectedPlanIdx === null) {
            toast1.error(LanguageString("2175"));
            return;
        }
        const plan = bridgeplan[selectedPlanIdx];
        // setSelectedPlan(plan);
        topupPay();
        // setShowUpgrade(false);
        // setShowTopupSummary(true);
    };

    const topupPay = async () => {
        try {
            if (selectedPlanIdx === null) {
                toast1.error(LanguageString("2175"));
                return;
            }
            let plan = selectedPlan;
            if (selectedCurrencyTopup === 'INR') delete plan.OtherCost;
            else delete plan.IndianCost;
            const Country = selectedCurrencyTopup === "INR" ? "India" : "Others";
            let json = {
                "Country": Country,
                "TopupType": plan.PlanType,
                "RequestedLimit": plan.Limit
            }
            const data = await topUpsOrder(json);
            if (data['ErrorCode'] === 3010) {
                displayRazorpayForTopup(data['ErrorMessage'], plan.PlanType, Country, plan.Limit)
            }

        } catch (error) {
            console.log(error);
        }
    }

    const displayRazorpayForTopup = async (data, topuptype, country, RequestedLimit) => {
        try {
            const res = await loadScript(
                "https://checkout.razorpay.com/v1/checkout.js"
            );
            if (!res) {
                alert(LanguageString("1967"));
                return;
            }
            let key = data['publicKey'];
            let orderid = data['OrderId'];
            let ammount = data['Amount'];
            let currency = data['Currency'];
            let name = data['Name'];
            let description = data['Description'];
            const options = {
                key: key,
                amount: ammount,
                currency: currency,
                name: name,
                description: description,
                order_id: orderid,
                handler: async function (response) {
                    const data = {
                        "payment_id": response.razorpay_payment_id,
                        "order_id": response.razorpay_order_id,
                        "signature": response.razorpay_signature,
                        "TopupType": topuptype,
                        "Country": country
                    };
                    let paymentverif = await topUpVerification(data);
                    if (paymentverif['ErrorCode'] === 3112) {
                        // Use the same invoice modals for top-ups
                        invoiceForTopup(paymentverif['ErrorMessage'], country, topuptype, RequestedLimit);
                        toast1.success(LanguageString("2176"));
                    } else {
                        toast1.error(LanguageString("2177"));
                    }
                },
                prefill: {
                    name: "",
                    email: "",
                    contact: "",
                },
                notes: {
                    address: "Cosmitude Softwares",
                },
                theme: {
                    color: "#61dafb",
                },
            };
            const RazorpayCtor = (window as any).Razorpay;
            const rzpTopup = new RazorpayCtor(options);
            rzpTopup.open();
        } catch (error) {
            console.log(error);
        }
    }

    const invoiceForTopup = (data, country, topuptype, RequestedLimit) => {
        try {
            if (country === 'India') {
                setInvoiceDisplay(true)
                const result = calculateGSTBreakdown((data.Amount) / 100);
                setAmmount((data.Amount) / 100)
                setTaxabelAmount(result.taxableAmount)
                setCGSTAmount(result.cgst)
                setSGSTAmount(result.sgst)
                setTotalAmount(result.total)
                setInvoicenumber(data.Invoice)
                setTopupType(topuptype)
                setTopupdata(RequestedLimit)
            } else {
                const result = calculateGSTBreakdown((data.Amount) / 100);
                setTopupType(topuptype)
                setTopupdata(RequestedLimit)
                setAmmount((data.Amount) / 100)
                setOtherInvoiceDisplay(true)
                setTotalAmount((data.Amount) / 100)
            }
        } catch (error) {

        }
    }

    const content = (
        <>
            {!isUserPro && (
                <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm
                  flex items-center justify-center
                  p-2 sm:p-4 overflow-y-auto">
                    {/* SHEET on mobile, DIALOG on desktop */}
                    <div className="w-full sm:max-w-3xl
                    max-h-[90vh] sm:max-h-[85vh]
                    bg-white rounded-2xl sm:rounded-lg
                    shadow-lg overflow-hidden flex flex-col my-auto">

                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b bg-white shrink-0 z-10">
                            <div className="flex items-center gap-2">
                                <CreditCard className="h-5 w-5 text-blue-600" />
                                <h3 className="text-lg font-semibold">{LanguageString("1673")}</h3>
                            </div>
                            <div className="flex gap-2">
                                <Button variant="ghost" size="sm" onClick={() => setShowUpgrade(false)}>
                                    {LanguageString("1463")}
                                </Button>
                            </div>
                        </div>

                        {/* BODY: scrolls independently */}
                        <div className="flex-1 min-h-0 overflow-y-auto p-4 sm:p-6 overscroll-contain">
                            <div className="space-y-6">
                                {/* FREE */}
                                <div className="rounded-2xl border border-slate-200/80 p-6 bg-white shadow-sm hover:shadow-md transition-all duration-300">
                                    <div className="flex items-center justify-between">
                                        <h4 className="text-lg font-bold text-slate-800 tracking-tight">{LanguageString("Free")}</h4>
                                        <span className="text-lg font-bold text-slate-800">₹0</span>
                                    </div>
                                    <p className="text-sm text-slate-500 mt-2">{LanguageString("2178")}</p>
                                    <ul className="mt-4 space-y-2.5 text-sm border-t border-slate-100 pt-4">
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2179")}</span>
                                        </li>
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2180")}</span>
                                        </li>
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2181")}</span>
                                        </li>
                                    </ul>
                                </div>

                                {/* PREMIUM */}
                                <div className="rounded-2xl border border-slate-200/80 p-6 bg-gradient-to-br from-white to-slate-50/40 shadow-sm hover:shadow-md transition-all duration-300 relative overflow-hidden group">
                                    {/* Accent gradient line at the top */}
                                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500" />

                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <h4 className="text-lg font-bold text-slate-800 tracking-tight">
                                                {LanguageString("2182")}
                                            </h4>
                                            {/* {billingCycle === 'yearly' && (
                                                <span className="bg-gradient-to-r from-emerald-500/10 to-teal-500/10 text-emerald-700 text-[10px] font-bold px-2.5 py-0.5 rounded-full border border-emerald-500/20 shadow-sm animate-pulse">
                                                    Save 20%
                                                </span>
                                            )} */}
                                        </div>
                                        <div className="flex justify-center my-5">
                                            <div className="inline-flex rounded-full bg-slate-100/80 p-1 border border-slate-200/60 w-full sm:w-auto shadow-inner">
                                                <button
                                                    type="button"
                                                    className={`flex-1 sm:flex-none px-5 py-1.5 text-xs font-semibold rounded-full transition-all duration-300 ${billingCycle === 'monthly'
                                                        ? 'bg-white text-slate-800 shadow-sm border border-slate-200/40'
                                                        : 'text-slate-500 hover:text-slate-800'
                                                        }`}
                                                    onClick={() => setBillingCycle('monthly')}
                                                >
                                                    {LanguageString("Monthly")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`flex-1 sm:flex-none px-5 py-1.5 text-xs font-semibold rounded-full transition-all duration-300 ${billingCycle === 'yearly'
                                                        ? 'bg-white text-slate-800 shadow-sm border border-slate-200/40'
                                                        : 'text-slate-500 hover:text-slate-800'
                                                        }`}
                                                    onClick={() => setBillingCycle('yearly')}
                                                >
                                                    {LanguageString("Yearly")}
                                                </button>
                                            </div>
                                        </div>
                                        <span className="text-xs font-semibold px-2.5 py-1 bg-indigo-50 text-indigo-700 rounded-full border border-indigo-100">
                                            {LanguageString("2183")}
                                        </span>
                                    </div>
                                    <p className="text-sm text-slate-500 mt-2">
                                        {LanguageString("2184")}
                                    </p>

                                    {/* Billing Cycle Switcher */}


                                    {/* Pricing & Call-to-action */}
                                    <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        {billingCycle === 'monthly' ? (
                                            <>
                                                <Button
                                                    className="bg-slate-900 text-white shadow hover:bg-slate-800 hover:shadow-md active:scale-[0.98] transition-all duration-200 py-5 rounded-xl border border-slate-800"
                                                    onClick={() => Upgrade('USD', 'Pro')}
                                                >
                                                    <CreditCard className="h-4 w-4 mr-2" />
                                                    {LanguageString("1835")}{selectcost?.other}/{LanguageString("2185")}
                                                </Button>
                                                <Button
                                                    className="bg-slate-900 text-white shadow hover:bg-slate-800 hover:shadow-md active:scale-[0.98] transition-all duration-200 py-5 rounded-xl border border-slate-800"
                                                    onClick={() => Upgrade('INR', 'Pro')}
                                                >
                                                    <CreditCard className="h-4 w-4 mr-2" />
                                                    {LanguageString("1834")} {selectcost?.India}/{LanguageString("2185")}
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    className="bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-md hover:shadow-lg hover:brightness-105 active:scale-[0.98] transition-all duration-200 py-5 rounded-xl"
                                                    onClick={() => Upgrade('USD', 'ProYearly')}
                                                >
                                                    <CreditCard className="h-4 w-4 mr-2" />
                                                    {LanguageString("1835")}{selectcost?.otherYearly}/year
                                                </Button>
                                                <Button
                                                    className="bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-md hover:shadow-lg hover:brightness-105 active:scale-[0.98] transition-all duration-200 py-5 rounded-xl"
                                                    onClick={() => Upgrade('INR', 'ProYearly')}
                                                >
                                                    <CreditCard className="h-4 w-4 mr-2" />
                                                    {LanguageString("1834")} {selectcost?.IndiaYearly}/year
                                                </Button>
                                            </>
                                        )}
                                    </div>

                                    {/* Features list */}
                                    <ul className="mt-5 space-y-2.5 text-sm border-t border-slate-100 pt-4">
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2186")}</span>
                                        </li>
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2187")}</span>
                                        </li>
                                    </ul>
                                </div>

                                {/* ENTERPRISE */}
                                <div className="rounded-2xl border border-slate-200/80 p-6 bg-white shadow-sm hover:shadow-md transition-all duration-300">
                                    <div className="flex items-center justify-between">
                                        <h4 className="text-lg font-bold text-slate-800 tracking-tight">{LanguageString("1704")}</h4>
                                        <span className="text-sm font-semibold px-2.5 py-1 bg-slate-100 text-slate-700 rounded-full border border-slate-200">
                                            {LanguageString("1853")}
                                        </span>
                                    </div>
                                    <p className="text-sm text-slate-500 mt-2">
                                        {LanguageString("2188")}
                                    </p>
                                    <ul className="mt-4 space-y-2.5 text-sm border-t border-slate-100 pt-4">
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2189")}</span>
                                        </li>
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2190")}</span>
                                        </li>
                                        <li className="flex items-center gap-2 text-slate-600">
                                            <Check className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                                            <span>{LanguageString("2191")}</span>
                                        </li>
                                    </ul>

                                    <div className="mt-5 border-t border-slate-100 pt-4 flex items-center justify-between">
                                        <span className="text-xs text-slate-400">Ready to scale?</span>
                                        <a
                                            href="mailto:sales@cosmitude.com"
                                            className="text-sm font-semibold text-indigo-600 hover:text-indigo-700 transition-colors"
                                        >
                                            {LanguageString("2192")} : sales@cosmitude.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* BRIDGE TOP-UPS MODAL */}
            {(isUserPro) && (
                <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
                    <div className="w-full sm:max-w-3xl max-h-[90vh] sm:max-h-[85vh] bg-white rounded-2xl sm:rounded-lg shadow-lg overflow-hidden flex flex-col my-auto">
                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b bg-white shrink-0 z-10">
                            <div className="flex items-center gap-2">
                                <CreditCard className="h-5 w-5 text-blue-600" />
                                <h3 className="text-lg font-semibold">{LanguageString("2173")}</h3>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => setShowUpgrade(false)}
                                    className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
                                >
                                    {LanguageString("1463")}
                                </button>
                            </div>
                        </div>

                        {/* Body */}
                        <div className="flex-1 min-h-0 overflow-y-auto p-5 sm:p-6 space-y-4">
                            {/* Currency toggle */}
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-medium">{LanguageString("1686")}:</span>
                                <div className="flex rounded-md overflow-hidden border">
                                    <button
                                        className={`px-3 py-1.5 text-sm ${selectedCurrencyTopup === 'INR' ? 'bg-gray-900 text-white' : 'bg-white text-gray-700'}`}
                                        onClick={() => setSelectedCurrencyTopup('INR')}
                                    >
                                        {LanguageString("2193")}
                                    </button>
                                    <button
                                        className={`px-3 py-1.5 text-sm border-l ${selectedCurrencyTopup === 'USD' ? 'bg-gray-900 text-white' : 'bg-white text-gray-700'}`}
                                        onClick={() => setSelectedCurrencyTopup('USD')}
                                    >
                                        {LanguageString("2194")}
                                    </button>
                                </div>
                            </div>

                            {/* Plans list */}
                            {bridgeplan.length === 0 ? (
                                <p className="text-sm text-gray-500">{LanguageString("2195")}</p>
                            ) : (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                    {bridgeplan
                                        .filter((plan) => {
                                            // Only include plans that have a valid cost in the selected currency
                                            if (selectedCurrencyTopup === 'INR') {
                                                return plan.IndianCost !== undefined;
                                            } else {
                                                return plan.OtherCost !== undefined;
                                            }
                                        })
                                        .map((plan: any, idx: number) => (
                                            <label
                                                key={`${plan.PlanType}-${plan.Limit}-${idx}`}
                                                className={`cursor-pointer rounded-lg border p-4 flex items-center justify-between gap-3 ${selectedPlanIdx === idx ? 'ring-2 ring-blue-600' : ''
                                                    }`}
                                            >
                                                <div>
                                                    <div className="text-base font-medium">{plan.Limit} {LanguageString("1702")}</div>
                                                    <div className="text-xs text-gray-500 mt-1">{LanguageString("1791")}: {plan.PlanType}</div>
                                                </div>
                                                <div className="flex items-center gap-4">
                                                    <div className="text-sm font-semibold">{getPlanPrice(plan)}</div>
                                                    <input
                                                        type="radio"
                                                        name="bridge-topup"
                                                        checked={selectedPlanIdx === idx}
                                                        onChange={() => { setSelectedPlanIdx(idx); setSelectedPlan(plan) }}
                                                        className="h-4 w-4"
                                                    />
                                                </div>
                                            </label>
                                        ))}
                                </div>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="px-4 py-3 border-t bg-white flex items-center justify-end gap-2">
                            <button
                                onClick={() => setShowUpgrade(false)}
                                className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
                            >
                                {LanguageString("Cancel")}
                            </button>
                            <button
                                onClick={onProceedTopup}
                                className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium text-white bg-gray-900 hover:bg-gray-800"
                            >
                                {LanguageString("476")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* {(isUserPro && type === 'Topup')&&(

            )} */}
            {/* INDIA INVOICE */}
            {invoicedisplay && (
                <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
                    <div className="w-full sm:max-w-3xl max-h-[90vh] sm:max-h-[85vh] bg-white rounded-2xl sm:rounded-lg shadow-lg overflow-hidden flex flex-col my-auto">
                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b bg-white shrink-0 z-10">
                            <div className="flex items-center gap-2">
                                <CreditCard className="h-5 w-5 text-blue-600" />
                                <h3 className="text-lg font-semibold">{LanguageString("1716")}</h3>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={cancel}
                                    className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
                                >
                                    {LanguageString("1463")}
                                </button>
                            </div>
                        </div>

                        {/* Body */}
                        <div ref={invoiceRef} className="flex-1 min-h-0 overflow-y-auto p-5 sm:p-6 font-sans">
                            <h2 className="text-center text-xl font-semibold">Cosmitude Softwares Private Limited</h2>

                            <p className="text-center mt-2 leading-relaxed">
                                #23, 4th Main, Vidyagiri Layout, Nagarabhavi 1st stage,<br />
                                Bengaluru – 560072, India<br />
                                Dial: +91 80 50396072 | www.cosmitude.com
                            </p>

                            <p className="text-center mt-2">GST: 29AAFCC6761L1Z4 &nbsp;&nbsp; PAN: AAFCC6761L</p>

                            <hr className="my-4 border-gray-200" />

                            {/* Bill-to row */}
                            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mt-3">
                                <div>
                                    <strong>Bill to:</strong>
                                    <div>
                                        <input
                                            type="text"
                                            value={customerName}
                                            onChange={e => setCustomerName(e.target.value)}
                                            placeholder="Enter name"
                                            className="invoice-field mt-1 w-full max-w-xs rounded-md border border-gray-200 px-3 py-2 text-sm outline-none focus:border-gray-900 focus:ring-2 focus:ring-black/10"
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            value={customerplace}
                                            onChange={e => setCustomerplace(e.target.value)}
                                            placeholder="Enter Address"
                                            className="invoice-field mt-1 w-full max-w-xs rounded-md border border-gray-200 px-3 py-2 text-sm outline-none focus:border-gray-900 focus:ring-2 focus:ring-black/10"
                                        />
                                    </div>
                                </div>

                                <div className="whitespace-nowrap">
                                    <strong>Date:</strong> <span>{getFormattedDate()}</span>
                                </div>
                            </div>

                            <div className="mt-4 flex items-baseline gap-2">
                                <strong>Invoice Number:</strong> <span>{invoicenumber}</span>
                            </div>

                            <div className="mt-3 flex items-baseline gap-2">
                                <strong>SAC:</strong>
                                <span>998313 - Information technology (IT) consulting and support services</span>
                            </div>

                            {/* Table */}
                            <div className="mt-5 w-full overflow-x-auto">
                                <table className="w-full min-w-[720px] border-collapse text-sm">
                                    <thead>
                                        <tr className="bg-gray-50">
                                            {[
                                                "Software Activity", "License", "Unit License", (topuptype && topupdata) ? "Credits Top-up" : "Monthly", !(topuptype && topupdata) && "Month",
                                                "Taxable Amount", "CGST 9%", "SGST 9%", "Total",
                                            ].filter(Boolean).map(h => (
                                                <th key={h} className="border border-gray-200 px-2 py-2 text-left font-semibold">{h}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-200 px-2 py-2">Cosmitude Bridge License</td>
                                            <td className="border border-gray-200 px-2 py-2">1</td>
                                            {topupdata ? (
                                                <>
                                                    <td className="border border-gray-200 px-2 py-2">{ammount}</td>
                                                    <td className="border border-gray-200 px-2 py-2">{topupdata}</td>
                                                </>
                                            ) : (
                                                <>
                                                    <td className="border border-gray-200 px-2 py-2">{ammount}</td>
                                                    <td className="border border-gray-200 px-2 py-2">{ammount}</td>
                                                    <td className="border border-gray-200 px-2 py-2">1</td>
                                                </>
                                            )}
                                            <td className="border border-gray-200 px-2 py-2">{taxableamount}</td>
                                            <td className="border border-gray-200 px-2 py-2">{cgstamount}</td>
                                            <td className="border border-gray-200 px-2 py-2">{sgstamount}</td>
                                            <td className="border border-gray-200 px-2 py-2">{totalammount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Footer actions */}
                        <div className="border-t bg-white px-4 py-3 flex justify-center">
                            <button
                                onClick={handleDownloadPDF}
                                className="inline-flex items-center justify-center rounded-md bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-black/90 active:translate-y-px"
                            >
                                {LanguageString("2196")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* USA INVOICE */}
            {otherinvoicedisplay && (
                <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 overflow-y-auto">
                    <div className="w-full sm:max-w-3xl max-h-[90vh] sm:max-h-[85vh] bg-white rounded-2xl sm:rounded-lg shadow-lg overflow-hidden flex flex-col my-auto">
                        {/* Header */}
                        <div className="flex items-center justify-between px-4 py-3 border-b bg-white shrink-0 z-10">
                            <div className="flex items-center gap-2">
                                <CreditCard className="h-5 w-5 text-blue-600" />
                                <h3 className="text-lg font-semibold">{LanguageString("1416")}</h3>
                            </div>
                            <div className="flex gap-2">
                                <button
                                    onClick={Othercancel}
                                    className="inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
                                >
                                    {LanguageString("1463")}
                                </button>
                            </div>
                        </div>

                        {/* Body */}
                        <div ref={invoiceRef} className="flex-1 min-h-0 overflow-y-auto p-5 sm:p-6 font-sans">
                            <h2 className="text-center text-xl font-semibold">Cosmitude Softwares Private Limited</h2>

                            <p className="text-center mt-2 leading-relaxed">
                                Cosmitude LLC<br />
                                5900, Balcones Drive Suite 100<br />
                                Austin TX 78731, USA
                            </p>

                            <p className="text-center mt-2">EIN – 35-2863044</p>

                            <hr className="my-4 border-gray-200" />

                            {/* Bill-to row */}
                            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mt-3">
                                <div>
                                    <strong>Bill to:</strong>
                                    <div>
                                        <input
                                            type="text"
                                            value={customerName}
                                            onChange={e => setCustomerName(e.target.value)}
                                            placeholder="Enter name"
                                            className="mt-1 w-full max-w-xs rounded-md border border-gray-200 px-3 py-2 text-sm outline-none focus:border-gray-900 focus:ring-2 focus:ring-black/10"
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            value={customerplace}
                                            onChange={e => setCustomerplace(e.target.value)}
                                            placeholder="Enter Address"
                                            className="mt-2 w-full max-w-xs rounded-md border border-gray-200 px-3 py-2 text-sm outline-none focus:border-gray-900 focus:ring-2 focus:ring-black/10"
                                        />
                                    </div>
                                </div>

                                <div className="whitespace-nowrap">
                                    <strong>Date:</strong> <span>{getFormattedDate()}</span>
                                </div>
                            </div>

                            <div className="mt-4 flex items-baseline gap-2">
                                <strong>Invoice Number:</strong> <span>{invoicenumber}</span>
                            </div>

                            {/* Table */}
                            <div className="mt-5 w-full overflow-x-auto">
                                <table className="w-full min-w-[640px] border-collapse text-sm">
                                    <thead>
                                        <tr className="bg-gray-50">
                                            {[
                                                "Software Activity", "License", "Unit License($)", (topuptype && topupdata) ? "Credits Top-up" : "Monthly($)", !(topuptype && topupdata) && "Month", "Total($)"
                                            ].filter(Boolean).map(h => (
                                                <th key={h} className="border border-gray-200 px-2 py-2 text-left font-semibold">{h}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="border border-gray-200 px-2 py-2">Cosmitude Bridge License</td>
                                            <td className="border border-gray-200 px-2 py-2">1</td>
                                            {topupdata ? (
                                                <>
                                                    <td className="border border-gray-200 px-2 py-2">{ammount}</td>
                                                    <td className="border border-gray-200 px-2 py-2">{topupdata}</td>
                                                </>
                                            ) : (
                                                <>
                                                    <td className="border border-gray-200 px-2 py-2">{ammount}</td>
                                                    <td className="border border-gray-200 px-2 py-2">{ammount}</td>
                                                    <td className="border border-gray-200 px-2 py-2">1</td>
                                                </>
                                            )}
                                            <td className="border border-gray-200 px-2 py-2">{totalammount}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Footer actions */}
                        <div className="border-t bg-white px-4 py-3 flex justify-center">
                            <button
                                onClick={handleDownloadPDF}
                                className="inline-flex items-center justify-center rounded-md bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-black/90 active:translate-y-px"
                            >
                                {LanguageString("2196")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

    if (typeof document === "undefined") return null;
    return createPortal(content, document.body);
};

export default UpgradePage;